import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { formatPoints } from "@/lib/format";
import { flattenRefTree } from "@/lib/refTree";

const LEVEL_STYLES = [
    "border-p2w-green/40 bg-p2w-green/5",
    "border-p2w-purple/40 bg-p2w-purple/5",
    "border-p2w-magenta/40 bg-p2w-magenta/5",
];

export default function ReferralTreeDialog({ open, onOpenChange, data }) {
    const rows = data ? flattenRefTree(data.tree) : [];
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-p2w-surface border-p2w-line text-white max-w-2xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="font-sora">
                        Red de referidos {data?.user ? `de @${data.user.username}` : ""}
                    </DialogTitle>
                </DialogHeader>
                {data && (
                    <div>
                        <div className="grid grid-cols-3 gap-2 mb-5">
                            <Mini label="Nivel 1" value={data.totals.l1} color="text-p2w-green" />
                            <Mini label="Nivel 2" value={data.totals.l2} color="text-p2w-purple" />
                            <Mini label="Nivel 3" value={data.totals.l3} color="text-p2w-magenta" />
                        </div>
                        <div className="rounded-lg bg-p2w-elevated border border-p2w-line p-3 mb-5 text-xs text-p2w-gray flex items-center justify-between">
                            <span>Ganancias por referidos</span>
                            <span className="font-sora font-bold text-p2w-green text-base number-tabular">
                                {formatPoints(data.earnings)} pts
                            </span>
                        </div>
                        {rows.length === 0 ? (
                            <p className="text-p2w-gray text-sm">Aún no tiene referidos.</p>
                        ) : (
                            <div className="space-y-2">
                                {rows.map((r) => (
                                    <div
                                        key={r.id}
                                        className={`rounded-xl border ${LEVEL_STYLES[r.level - 1]} p-3 flex items-center justify-between`}
                                        style={{ marginLeft: (r.level - 1) * 20 }}
                                    >
                                        <div className="flex items-center gap-2">
                                            <Badge className="bg-p2w-elevated border-p2w-line text-p2w-gray text-[10px]">L{r.level}</Badge>
                                            <Avatar className="w-7 h-7">
                                                <AvatarImage src={r.avatar_url} />
                                                <AvatarFallback className="bg-p2w-purple text-white text-[10px]">
                                                    {(r.username || "?").slice(0, 2).toUpperCase()}
                                                </AvatarFallback>
                                            </Avatar>
                                            <span className="text-sm font-medium text-white">@{r.username}</span>
                                        </div>
                                        <span className="text-xs font-sora font-bold text-p2w-green number-tabular">
                                            {formatPoints(r.points_balance)} pts
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}

function Mini({ label, value, color }) {
    return (
        <div className="rounded-lg bg-p2w-elevated border border-p2w-line p-3 text-center">
            <div className="text-[10px] uppercase tracking-widest text-p2w-gray">{label}</div>
            <div className={`mt-1 font-sora font-extrabold text-2xl number-tabular ${color}`}>{value}</div>
        </div>
    );
}
